import { render, staticRenderFns } from "./CardVagas.vue?vue&type=template&id=70778395&scoped=true"
import script from "./CardVagas.vue?vue&type=script&lang=js"
export * from "./CardVagas.vue?vue&type=script&lang=js"
import style0 from "./CardVagas.vue?vue&type=style&index=0&id=70778395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70778395",
  null
  
)

export default component.exports